import React from "react";
// import React, { useContext, useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";
// import PageHeader from "../../../components/Headers/PageHeader";
// import PageMain from "../../../components/Main/PageMain";
// import useFetch from "../../../hooks/useFetch";
// import * as api from "../../../constants/api";
// import Spinner from "../../../components/Spinner";
// import { useNavigate } from "react-router";
// import * as r from "../../../constants/routes";
import classes from "./CardBlue.module.scss";
// import Title from "../../../components/Title";
import dash_people from "./../../../assets/images/dashboard_images/dash_people.svg";

interface Interface {
  title?: string;
  desc?: string;
  number?: number;
  open?: any;
  setOpen?: any;
  setIndexCardWhite?: any;
  setIndexCardBlue?: any;
  index?: any;
}

const CardBlue = ({
  title,
  desc,
  number,
  setOpen,
  open,
  setIndexCardWhite,
  setIndexCardBlue,
  index,
}: Interface) => {
  // const { t } = useTranslation();
  // const history = useNavigate();

  return (
    <div
      onClick={() => {
        setOpen(true);
        setIndexCardBlue(index);
        setIndexCardWhite(null);
      }}
      className={classes.CardWhite}
    >
      <div className={classes.CardTop}>
        <div className={classes.Title}>{title}</div>
      </div>
      <div className={classes.CardBottom}>
        <img className={classes.Image} src={dash_people} alt="" />
        <div className={classes.CardBottomLeft}>
          <div className={classes.NumberArea}>
            <div className={classes.UsersNumber}>{number}</div>
            <div className={classes.SeeUsers}>ver usuários</div>
          </div>
          <div className={classes.Desc}>{desc}</div>
        </div>
      </div>
    </div>
  );
};

export default CardBlue;
